import Vue from 'vue';


export interface IFile {
    name?: string;
    type?: string;
    file?: string | ArrayBuffer
}

export class FileManager extends Vue {
    snackbar: { open?: boolean, timeout?: number, text?: string, color?: string }
    constructor(){
        super()
        this.snackbar = {
            open: false,
            timeout: 4000,
            text: '',
            color: 'primaryDark'
        }
    }


    convertToBase64(file: File): Promise<FileReader> {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        return Promise.resolve(fileReader)
    }

    fileType(type: string){
        return type.includes("image") ? "image" :
                      type.includes("application") || type.includes("text") ? "document" :
                         type.includes("video") ? "video" : "default"
    }

    displaySnackBar(text, color?, timeout?) {
        this.snackbar.open = true;
        this.snackbar.text = text;
        this.snackbar.color = color || this.snackbar.color;
        this.snackbar.timeout = timeout || this.snackbar.timeout;
    }
}


// WEBPACK FOOTER //
// ./src/components/attachment-manager/index.ts